import React from "react";
import { Group } from "@mantine/core";
import TagDeleteActionButton from "./TagDeleteActionButton";
import UpdateTagActionIcon from "./UpdateTagActionIcon";
import ManageTagAssigneeActionIcon from "./ManageTagAssigneeActionIcon";

export type TagTableActionMenuProps = {
  id: number;
};

const TagTableActionMenu: React.FC<TagTableActionMenuProps> = ({ id }) => (
  <Group spacing="md" noWrap>
    <ManageTagAssigneeActionIcon id={id} />
    <UpdateTagActionIcon id={id} />
    <TagDeleteActionButton id={id} />
  </Group>
);

export default TagTableActionMenu;
